import { motion, useScroll } from "framer-motion";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollExperience = () => {
  const { scrollYProgress } = useScroll();
  const { pathname } = useLocation();

  useEffect(() => {
    const sections = [...document.querySelectorAll("main > section")];
    sections.forEach((section, index) => {
      section.classList.add("cinematic-reveal");
      section.style.setProperty("--reveal-index", index);
    });
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => entry.target.classList.toggle("is-visible", entry.isIntersecting));
    }, { threshold: .08, rootMargin: "0px 0px -8% 0px" });
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, [pathname]);

  useEffect(() => {
    const move = (event) => {
      document.documentElement.style.setProperty("--pointer-x", `${event.clientX}px`);
      document.documentElement.style.setProperty("--pointer-y", `${event.clientY}px`);
    };
    window.addEventListener("pointermove", move, { passive: true });
    return () => window.removeEventListener("pointermove", move);
  }, []);

  return <><motion.div className="cinematic-progress" style={{ scaleY: scrollYProgress }} data-testid="cinematic-scroll-progress"/><div className="cursor-aura" aria-hidden="true"/></>;
};
